export default "__VITE_ASSET__DNRHyN1r__"